export enum FilterOperatorEnum {
  Equal = 'EQUAL',
  Contains = 'CONTAINS',
  In = 'IN',
  Between = 'BETWEEN',
  WithinDate = 'WITHIN_DATE',
  GreaterOrEqual = 'GREATER_OR_EQUAL',
  LessOrEqual = 'LESS_OR_EQUAL',
}
